var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.609 1.81396L13.792 12L3.61 22.186C3.42894 22.1098 3.27443 21.9819 3.16589 21.8182C3.05736 21.6545 2.99964 21.4624 3 21.266V2.73396C3.00008 2.53779 3.05786 2.34596 3.16614 2.18238C3.27443 2.01879 3.42844 1.89067 3.609 1.81396ZM14.499 12.707L16.801 15.009L5.864 21.342L14.499 12.707ZM17.698 9.50896L20.505 11.135C20.6565 11.2229 20.7823 11.349 20.8698 11.5009C20.9572 11.6527 21.0032 11.8248 21.0032 12C21.0032 12.1752 20.9572 12.3473 20.8698 12.4991C20.7823 12.6509 20.6565 12.7771 20.505 12.865L17.697 14.491L15.206 12L17.698 9.50896ZM5.864 2.65796L16.802 8.98996L14.499 11.293L5.864 2.65796Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGray);
export default __webpack_public_path__ + "static/media/GoogleGray.2061c4268a9973707786cfaa48925166.svg";
export { ForwardRef as ReactComponent };